import { render, staticRenderFns } from "./SitePSM.vue?vue&type=template&id=5bc0ca74&"
import script from "./SitePSM.vue?vue&type=script&lang=js&"
export * from "./SitePSM.vue?vue&type=script&lang=js&"
import style0 from "./SitePSM.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports